// extracted by mini-css-extract-plugin
export default {"div":"FolderPage_div__IwVjM","NoteFolderList":"FolderPage_NoteFolderList__mb2Ji"};